<script setup>
import SingleTextDisapprovalModal from './SingleTextDisapprovalModal.vue';
import SuccessModal from './SuccessModal.vue';
import PublishConfirmationModal from "@/components/approval-center/modals/PublishConfirmationModal.vue";
import {ref, watch} from 'vue';

const inputValue = defineModel({
  type: String,
  required: true,
});

const emit = defineEmits(['close', 'confirm']);

const input = ref('');
watch(() => inputValue.value, (newValue) => (input.value = newValue), { immediate: true });

const showSuccessModal = ref(false);
const showConfirmationModal = ref(false);

const handlePreConfirm = () => {
  showConfirmationModal.value = true;
};

const handleConfirm = () => {
  showConfirmationModal.value = false;
  emit('update:modelValue', input.value);
  emit('confirm');
  showSuccessModal.value = true;
};
</script>

<template>
  <SingleTextDisapprovalModal
    v-if="!showSuccessModal && !showConfirmationModal"
    v-model="input"
    @close="emit('close')"
    @confirm="handlePreConfirm"
  >
    <slot />

    <template #label>
      <slot name="label" />
    </template>
  </SingleTextDisapprovalModal>

  <PublishConfirmationModal
    v-else-if="showConfirmationModal"
    :input="input"
    @back="showConfirmationModal = false"
    @confirm="handleConfirm"
  >
    <template #label>
      <slot name="label" />
    </template>
  </PublishConfirmationModal>

  <SuccessModal
    v-else
    @close="emit('close')"
  />
</template>
